export default {
  'projectBuilder.title': 'Project builder',
  'projectBuilder.back': 'Back',
  'projectBuilder.revision': 'Revision {revision}',
  'projectBuilder.revision.number': 'Version',
  'projectBuilder.revision.status': 'Status',
  'projectBuilder.chat.title': 'AI Assistant',
  'projectBuilder.chat.open': 'Open chat',
  'projectBuilder.chat.close': 'Close chat',
  'projectBuilder.readOnly': 'Read only',
  'projectBuilder.active': 'Active',
  'projectBuilder.inactive': 'Inactive',
  'projectBuilder.settings': 'Description',
  'projectBuilder.more': 'More options',
  'projectBuilder.menu.description': 'Edit',
  'projectBuilder.edit.title': 'Edit project',
  'projectBuilder.menu.activate': 'Activate',
  'projectBuilder.menu.deactivate': 'Deactivate',
  'projectBuilder.menu.delete': 'Delete',
  'projectBuilder.error.notFound': 'The project does not exist or you cannot access it',
  'projectBuilder.error.readOnly': 'You cannot change this project',

  'projectBuilder.section.canvas': 'Canvas',
  'projectBuilder.section.artifacts': 'Resources',
  'projectBuilder.section.collaborators': 'Collaborators',
  'projectBuilder.section.access': 'Use access',
  'projectBuilder.section.documents': 'Documents',

  'projectBuilder.canvas.empty': 'This project has no resources yet',
  'projectBuilder.canvas.empty.hint':
    'Associate resources in each group, or ask the assistant to shape the solution.',
  'projectBuilder.map.data': 'Data',
  'projectBuilder.map.data.hint': 'Entities and lists',
  'projectBuilder.map.operation': 'Operations',
  'projectBuilder.map.operation.hint': 'Processes and apps',
  'projectBuilder.map.intelligence': 'Intelligence',
  'projectBuilder.map.intelligence.hint': 'Agents and skills',
  'projectBuilder.map.organization': 'Organization',
  'projectBuilder.map.organization.hint': 'Areas, positions and groups',
  'projectBuilder.map.count': '{count} resources',
  'projectBuilder.artifacts.empty': 'No resources of this type yet',
  'projectBuilder.artifacts.add': 'Associate',
  'projectBuilder.artifacts.open': 'Open',
  'projectBuilder.artifacts.unlink': 'Unlink',
  'projectBuilder.artifacts.refresh': 'Refresh name',
  'projectBuilder.artifacts.unavailable': 'Unavailable',
  'projectBuilder.artifacts.unavailable.hint':
    'The resource is gone or you cannot see it. You can remove the association.',
  'projectBuilder.artifacts.picker.title': 'Associate {type}',
  'projectBuilder.artifacts.picker.search': 'Search',
  'projectBuilder.artifacts.picker.empty': 'No results',
  'projectBuilder.artifacts.unlink.confirm':
    'This removes the project association. The resource stays and is managed on its own screen.',

  'projectBuilder.artifact.app': 'Apps',
  'projectBuilder.artifact.dynamic-entity': 'Entities',
  'projectBuilder.artifact.custom-list': 'Lists',
  'projectBuilder.artifact.process': 'Processes',
  'projectBuilder.artifact.ai-agent': 'Agents',
  'projectBuilder.artifact.ai-skill': 'Skills',
  'projectBuilder.artifact.area': 'Areas',
  'projectBuilder.artifact.position': 'Positions',
  'projectBuilder.artifact.user-group': 'User groups',

  'projectBuilder.listType.list': 'Table',
  'projectBuilder.listType.gantt': 'Gantt',
  'projectBuilder.listType.calendar': 'Calendar',
  'projectBuilder.listType.taskList': 'Task list',
  'projectBuilder.listType.taskBoard': 'Board',
  'projectBuilder.listType.cards': 'Cards',
  'projectBuilder.listType.map': 'Map',

  'projectBuilder.collaborators.add': 'Add collaborator',
  'projectBuilder.collaborators.empty': 'Nobody else can manage this project',
  'projectBuilder.collaborators.warning':
    'A collaborator can manage the project. They do not automatically receive access to every linked resource.',
  'projectBuilder.collaborators.remove': 'Remove',
  'projectBuilder.collaborators.remove.confirm':
    'This person will no longer manage the project. The change applies on the next operation.',
  'projectBuilder.collaborators.picker.title': 'Add collaborator',
  'projectBuilder.collaborators.picker.search': 'Search by name or email',

  'projectBuilder.access.description':
    'These rules only allow reading and using the project. They do not grant management or access to linked resources. User groups are stored, but they do not grant access yet. If the session has no area, that category is not evaluated.',

  'projectBuilder.description.title': 'Description',
  'projectBuilder.description.label': 'Description',
  'projectBuilder.description.required': 'Description is required',
  'projectBuilder.name.required': 'Name is required',
  'projectBuilder.name.max': 'Maximum 50 characters',
  'projectBuilder.description.max': 'Maximum 250 characters',

  'projectBuilder.create.title': 'New project',
  'projectBuilder.create.name': 'Name',
  'projectBuilder.create.description': 'Description',
  'projectBuilder.create.active': 'Active',
  'projectBuilder.create.submit': 'Create',
  'projectBuilder.create.success': 'Project created',

  'projectBuilder.delete.title': 'Delete project',
  'projectBuilder.delete.body':
    'The project and its associations will be removed. Linked resources remain and are managed on their own screens.',

  'projectBuilder.review.conflict':
    'Someone else changed the composition. The project was reloaded. Review the change and apply it again if you still need it.',
  'projectBuilder.review.uncertain':
    'We could not confirm whether the change was saved. The composition was reloaded before another attempt.',
  'projectBuilder.review.retry': 'Retry',
  'projectBuilder.review.dismiss': 'Dismiss',

  'projectBuilder.documents.kicker': 'Project',
  'projectBuilder.documents.title': 'Documents',
  'projectBuilder.documents.summary':
    'Files that belong to this project. Download uses the project route, and the plan file stays.',
  'projectBuilder.documents.root': 'Project folder',
  'projectBuilder.documents.empty': 'This folder has no files',
  'projectBuilder.documents.empty.hint': 'Upload a file or create a subfolder.',
  'projectBuilder.documents.missing': 'This project does not have a document folder yet',
  'projectBuilder.documents.missing.hint': 'Once created, files stay in this project only.',
  'projectBuilder.documents.missing.readOnly':
    'A project manager has to create the document folder.',
  'projectBuilder.documents.init': 'Create folder',
  'projectBuilder.documents.upload': 'Upload',
  'projectBuilder.documents.newFolder': 'New folder',
  'projectBuilder.documents.folderName': 'Folder name',
  'projectBuilder.documents.createFolder': 'Create',
  'projectBuilder.documents.download': 'Download',
  'projectBuilder.documents.delete': 'Delete',
  'projectBuilder.documents.deleteDoc.title': 'Delete document',
  'projectBuilder.documents.deleteDoc.body': 'The file is removed from the project folder.',
  'projectBuilder.documents.deleteFolder.title': 'Delete folder',
  'projectBuilder.documents.deleteFolder.body':
    'The subfolder is removed. The project folder stays.',
  'projectBuilder.documents.external':
    'This file belongs to another origin and cannot be deleted from the project.',
  'projectBuilder.documents.loadMore': 'Load more',
  'projectBuilder.plan.kicker': 'Project',
  'projectBuilder.plan.title': 'Plan',
  'projectBuilder.plan.summary':
    'The project PLAN.md. Saving creates the folder when it is missing and keeps the stored name.',
  'projectBuilder.plan.empty.title': 'There is no plan yet',
  'projectBuilder.plan.empty.text': 'When you write it, it is saved as the project PLAN.md.',
  'projectBuilder.plan.empty.start': 'Write the plan',
  'projectBuilder.plan.history': 'Revisions',
  'projectBuilder.plan.revision': 'Revision {number}',
  'projectBuilder.plan.viewing': 'You are viewing revision {number}.',
  'projectBuilder.plan.restore': 'Bring into the editor',
  'projectBuilder.plan.conflict': 'The plan changed. Load the current version before saving again.',
  'projectBuilder.plan.reload': 'Load current version',
  'projectBuilder.section.plan': 'Plan',
  'projectBuilder.section.design': 'Design',
  'projectBuilder.diagram.preview.kicker': 'Preview of this proposal',
  'projectBuilder.diagram.live.kicker': 'Latest admitted design',
  'projectBuilder.diagram.live.revision': 'Plan revision {number}',
  'projectBuilder.diagram.status.preparing': 'Preparing proposal',
  'projectBuilder.diagram.status.needsInformation': 'Information needed',
  'projectBuilder.diagram.status.needsReview': 'Needs review',
  'projectBuilder.diagram.status.ready': 'Ready to build',
  'projectBuilder.diagram.layer.people': 'People and organization',
  'projectBuilder.diagram.layer.apps': 'Applications',
  'projectBuilder.diagram.layer.automation': 'Automation',
  'projectBuilder.diagram.layer.data': 'Information and results',
  'projectBuilder.diagram.type.person': 'Person',
  'projectBuilder.diagram.type.report': 'Report',
  'projectBuilder.diagram.type.app': 'Application',
  'projectBuilder.diagram.type.dynamic-entity': 'Entity',
  'projectBuilder.diagram.type.custom-list': 'List',
  'projectBuilder.diagram.type.process': 'Process',
  'projectBuilder.diagram.type.ai-agent': 'AI agent',
  'projectBuilder.diagram.type.ai-skill': 'Skill',
  'projectBuilder.diagram.type.area': 'Area',
  'projectBuilder.diagram.type.position': 'Position',
  'projectBuilder.diagram.type.user-group': 'User group',
  'projectBuilder.diagram.type.unknown': 'Component',
  'projectBuilder.diagram.state.conceptual': 'Conceptual',
  'projectBuilder.diagram.state.planned': 'To create',
  'projectBuilder.diagram.state.plannedLive': 'Planned',
  'projectBuilder.diagram.state.existing': 'Existing',
  'projectBuilder.diagram.state.building': 'In progress',
  'projectBuilder.diagram.state.built': 'Built',
  'projectBuilder.diagram.state.unlinked': 'Unlinked',
  'projectBuilder.diagram.state.unavailable': 'Unavailable',
  'projectBuilder.diagram.state.failed': 'Needs attention',
  'projectBuilder.diagram.state.missing': 'Status unavailable',
  'projectBuilder.diagram.detail.proposal.conceptual': 'Explains the system and is not built.',
  'projectBuilder.diagram.detail.proposal.planned': 'It will be created.',
  'projectBuilder.diagram.detail.proposal.existing':
    'It already belongs to the project, or the plan reuses, configures, or keeps it.',
  'projectBuilder.diagram.detail.proposal.missing':
    'This proposal did not include a status for the component.',
  'projectBuilder.diagram.detail.live.conceptual': 'Explanatory component. It is not built.',
  'projectBuilder.diagram.detail.live.planned': 'Planned. There is no work in progress yet.',
  'projectBuilder.diagram.detail.live.existing': 'It was already in the project.',
  'projectBuilder.diagram.detail.live.building':
    'Work is queued, running, or can still be retried.',
  'projectBuilder.diagram.detail.live.built':
    'Construction produced the artifact and it is still linked.',
  'projectBuilder.diagram.detail.live.unlinked':
    'Construction finished, but the artifact is no longer in the project.',
  'projectBuilder.diagram.detail.live.unavailable':
    'The design cites an artifact that is no longer available.',
  'projectBuilder.diagram.detail.live.failed':
    'A step failed, or a pending step is blocked by a required failure.',
  'projectBuilder.diagram.detail.live.missing': 'Status unavailable. Read the diagram again.',
  'projectBuilder.diagram.action.create': 'Create',
  'projectBuilder.diagram.action.link': 'Link',
  'projectBuilder.diagram.action.configure': 'Configure',
  'projectBuilder.diagram.action.no-op': 'Keep',
  'projectBuilder.diagram.legend.relation': 'Design relationship',
  'projectBuilder.diagram.legend.proposal': 'No execution order',
  'projectBuilder.diagram.legend.live': 'Progress is shown on the components',
  'projectBuilder.diagram.legend.none': 'No declared relationships',
  'projectBuilder.diagram.empty.live.title': 'There is no admitted design yet',
  'projectBuilder.diagram.empty.live': 'The diagram appears when a construction is admitted.',
  'projectBuilder.diagram.empty.live.hint':
    'The proposal is prepared in the chat. Once it is admitted, the solution map stays in this view.',
  'projectBuilder.diagram.inspector.detail': 'Detail',
  'projectBuilder.diagram.inspector.empty': 'Nothing selected',
  'projectBuilder.diagram.inspector.relation': 'Relationship',
  'projectBuilder.diagram.inspector.designName': 'Name in the design',
  'projectBuilder.diagram.inspector.open': 'Open resource',
  'projectBuilder.diagram.inspector.incoming': 'Comes from {name}: {label}',
  'projectBuilder.diagram.inspector.outgoing': 'Goes to {name}: {label}',
  'projectBuilder.diagram.error.read': 'The diagram could not be read.',
  'projectBuilder.diagram.error.denied': 'You do not have access to this diagram.',
  'projectBuilder.diagram.error.edge': 'A relationship in the diagram could not be read.',
  'projectBuilder.diagram.retry': 'Try again',
  'projectBuilder.diagram.expand': 'Expand map',
  'projectBuilder.diagram.zoom.in': 'Zoom in',
  'projectBuilder.diagram.zoom.out': 'Zoom out',
  'projectBuilder.diagram.zoom.fit': 'Fit',
  'projectBuilder.diagram.zoom.reflow': 'Rearrange view',
};
